import scrollLock from './functions/_scrollLock.js' // スクロールロック

import getCookie from './functions/_cookie-getCookie.js' // Cookie取得
import setCookie from './functions/_cookie-setCookie.js' // Cookie発行

const isAuth = getCookie('isAuth') // Cookie取得

if (isAuth !== 'on') {
  // モーダルを出す
  document.getElementById('modalOverlay').classList.add('active')
  document.getElementById('modalOverlay').classList.add('md-overlay--r18')
  document.querySelector('.js-modal--r18').classList.add('active')
  scrollLock('body', '#modalOverlay')

  // 認証を終える
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-authAgree')) {
      return
    }
    setCookie('isAuth', 'on', 60 * 60 * 24 * 7, false) // 認証状態をCookieに格納

    document.getElementById('modalOverlay').classList.remove('md-overlay--r18')
  })
}
